import Vue from "vue";

export default Vue.extend( {
  data: () => ( {
    sessionStorageKeys: {
      notificationBanner: "notificationBanner"
    },
    notificationSessionData: { notifications: { dismissed: {} } }
  } ),
  mounted () {
    this.setNotificationSessionData();
  },
  methods: {
    hasNotificationBeenDismissed ( key ) {
      const {
        notifications: { dismissed }
      } = this.notificationSessionData;
      const hasBeenDismissed = dismissed[key];
      return hasBeenDismissed === true;
    },
    setNotificationSessionData () {
      this.notificationSessionData = this.getNotificationSessionData();
    },
    getNotificationSessionData () {
      return (
        this.getSessionStorage( this.sessionStorageKeys.notificationBanner )
        || this.notificationSessionData
      );
    },
    dismissNotificationBanner ( key ) {
      const {
        notifications: { dismissed }
      } = this.getNotificationSessionData();

      const mutableDismissed = { ...dismissed, [key]: true };

      const notificationsData = {
        notifications: {
          dismissed: {
            ...mutableDismissed
          }
        }
      };

      this.setSessionStorage( this.sessionStorageKeys.notificationBanner, notificationsData );
      this.notificationSessionData = notificationsData;
    },
    setSessionStorage ( key, value ) {
      try {
        window.sessionStorage.setItem( key, JSON.stringify( value ) );
      } catch ( ex ) {
        console.error(
          `Device application data capacity potentially full. Check exception: ${ex}`
        );
      }
    },
    getSessionStorage ( key ) {
      // console.log( "session storage", window.sessionStorage );
      return JSON.parse( window.sessionStorage.getItem( key ) );
    }
  }
} );
